
export default function BlankPage(){
    return (
        <div>
        </div>
    );
}